/**
 * One-shot Leaflet bootstrap.
 *
 * Leaflet's default marker icon URLs are baked-in PNG paths that break under
 * bundlers (Vite/webpack) — the `<img>` src ends up as a relative path the
 * page can't resolve, producing invisible markers. Rebind the prototype's
 * default icon so any un-customised `L.Marker` still renders.
 *
 * We use custom `L.divIcon` markers everywhere in-app, so this is defensive —
 * but cheap enough to always run, and it saves a future contributor a
 * confusing debugging session if they add a bare `L.marker()`.
 *
 * Also pulls in Leaflet's stylesheet so tile grids, controls, and popups
 * render with their default chrome. Import this file exactly once from
 * `main.tsx` (or a test setup file).
 */
import L from 'leaflet';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import icon from 'leaflet/dist/images/marker-icon.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';

L.Marker.prototype.options.icon = L.icon({
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: shadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
